(function () {
  function initPumpkinTestimonials() {
    document.querySelectorAll('[data-pl-testimonials]').forEach(function (section) {
      var viewport = section.querySelector('[data-pl-viewport]');
      var track = section.querySelector('[data-pl-track]');
      var cards = section.querySelectorAll('[data-pl-card]');
      var prev = section.querySelector('[data-pl-prev]');
      var next = section.querySelector('[data-pl-next]');
      var progress = section.querySelector('[data-pl-progress]');
      if (!viewport || !track || !cards.length) return;

      var index = 0;
      var autoplay = section.getAttribute('data-autoplay') === 'true';
      var autoplayMs = parseInt(section.getAttribute('data-autoplay-ms'), 10) || 6000;
      var timer = null;

      function slidesVisible() {
        var n = parseInt(section.getAttribute('data-slides-visible'), 10) || 4;
        if (window.matchMedia('(max-width: 560px)').matches) return 1;
        if (window.matchMedia('(max-width: 800px)').matches) return Math.min(n, 2);
        if (window.matchMedia('(max-width: 1100px)').matches) return Math.min(n, 3);
        return n;
      }

      function maxIndex() {
        return Math.max(0, cards.length - slidesVisible());
      }

      function updateProgress() {
        if (!progress) return;
        var max = maxIndex();
        if (max === 0) {
          progress.style.width = '100%';
          return;
        }
        var pct = ((index + 1) / (max + 1)) * 100;
        progress.style.width = pct + '%';
      }

      function render() {
        var card = cards[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        var cardWidth = card.getBoundingClientRect().width;
        var step = cardWidth + gap;
        track.style.transform = 'translateX(-' + (index * step) + 'px)';

        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex();
        updateProgress();
      }

      function go(delta) {
        index += delta;
        if (index < 0) index = 0;
        if (index > maxIndex()) index = maxIndex();
        render();
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay || cards.length <= slidesVisible()) return;
        timer = setInterval(function () {
          if (index >= maxIndex()) index = 0;
          else index += 1;
          render();
        }, autoplayMs);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          go(-1);
          startAutoplay();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          go(1);
          startAutoplay();
        });
      }

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (index > maxIndex()) index = maxIndex();
          render();
        }, 120);
      });

      render();
      startAutoplay();
    });
  }

  function initPumpkinFaq() {
    document.querySelectorAll('[data-pl-faq]').forEach(function (item) {
      var btn = item.querySelector('.pl-faq__btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init() {
    initPumpkinTestimonials();
    initPumpkinFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
